<template>
  <v-container fluid class="jobposting-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Job Posting</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Posting</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_jobposting.jobtitle"
                          v-bind:error="error == 'jobtitle'"
                          outlined
                          dense
                          placeholder="Job Title"
                          persistent-hint
                          single-line hint="Enter the job title">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_jobposting.joblocation"
                          v-bind:error="error == 'jobtype'"
                          outlined
                          dense
                          placeholder="Job Location"
                          persistent-hint
                          single-line hint="Enter the job location">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="['Full Time', 'Part Time', 'Contract']"
                          v-model="new_jobposting.jobtype"
                          v-bind:error="error == 'jobtype'"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the job type">
                        </v-select>

                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-3"
                          :items="departments.map(x => { return {text: x.departmentname, value: x._id} })"
                          v-model="new_jobposting.departmentid"
                          v-bind:error="error == 'departmentid'"
                          outlined
                          dense
                          placeholder="Department"
                          persistent-hint
                          single-line hint="Please choose the department">
                        </v-select>
                        <v-menu
                          ref="menu_postingdate"
                          v-model="menu_postingdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_jobposting.postingdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_jobposting.postingdate"
                              label="Posting Date"
                              v-bind="attrs"
                              v-bind:value="new_jobposting.postingdate"
                              v-bind:error="error == 'postingdate'"
                              v-on="on"
                              single-line hint="Enter posting date"
                              persistent-hint
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_jobposting.postingdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_postingdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_postingdate.save(new_jobposting.postingdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_postingenddate"
                          v-model="menu_postingenddate"
                          :close-on-content-click="false"
                          :return-value.sync="new_jobposting.postingenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_jobposting.postingenddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="new_jobposting.postingenddate"
                              v-on="on"
                              single-line hint="Enter the end date"
                              persistent-hint
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_jobposting.postingenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_postingenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_postingenddate.save(new_jobposting.postingenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          to="/jobposting/list"
                          replace
                          outlined
                          color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertJobPosting()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      new_jobposting: {},
      menu_postingdate: false,
      menu_postingenddate: false,
      items: ['Full Time', 'Part Time', 'Contract', 'Remote'],
      error: null,
      errorindex: null,
    }
  },
  computed: {
    ...mapState('JobPosting', ['isReceiving']),
    ...mapState('Department', ['departments']),
  },
  methods: {
    ...mapActions('JobPosting', ['insertJobPostingRequest', 'getJobPostingsRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    checkError(){
      if(!this.new_jobposting.jobtitle){
        this.error = 'jobtitle';
        return false;
      }
      if(!this.new_jobposting.joblocation){
        this.error = 'joblocation';
        return false;
      }
      if(!this.new_jobposting.jobtype){
        this.error = 'jobtype';
        return false;
      }
      if(!this.new_jobposting.departmentid){
        this.error = 'departmentid';
        return false;
      }
      if(!this.new_jobposting.postingdate){
        this.error = 'postingdate';
        return false;
      }
      this.error = null;
      return true;
    },
    async insertJobPosting() {
      if(!this.checkError()) return;
      await this.insertJobPostingRequest(this.new_jobposting);
      router.push('/jobposting/list');
    },
  },
  async created () {
    if(this.departments.length==0) await this.getDepartmentsRequest();
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
